export const useFavorites = () => {
  const { API_ENDPOINTS } = useApiEndpoints()
  const authStore = useAuthStore()
  const toast = useCustomToast()
  
  const loading = ref({
    add: false,
    remove: false
  })
  
  // Kullanıcı favorileri
  const favorites = ref([])
  
  // Kullanıcının tüm favorilerini getir
  const fetchFavorites = async (page = 1, perPage = 20) => {
    if (!authStore.isAuthenticated) return { favorites: [] }
    
    try {
      // Sayfa parametresini ekle
      const url = `${API_ENDPOINTS.protected.favorites.list}?page=${page}&per_page=${perPage}`
      const response = await useBaseOFetchWithAuth(url)
      
      // API cevabının favorites dizisini ve sayfalama bilgilerini sakla
      favorites.value = response.data?.favorites || []
      
      // response.data içinde favorites ve sayfalama bilgileri var, tamamını döndür
      return response.data
    } catch (error) {
      console.error('Favorileri getirme hatası:', error)
      return { favorites: [] }
    }
  }
  
  // Favorilere ürün ekle
  const addToFavorites = async (product) => {
    if (!authStore.isAuthenticated) {
      navigateTo('/auth?callback=' + window.location.pathname)
      return false
    }
    
    loading.value.add = true
    try {
      await useBaseOFetchWithAuth(API_ENDPOINTS.protected.favorites.add, {
        method: 'POST',
        body: JSON.stringify({ product_id: product.id })
      })
      
      product.is_favorite = true
      await fetchFavorites()
      return true
    } finally {
      loading.value.add = false
    }
  }
  
  // Favorilerden ürün çıkar
  const removeFromFavorites = async (product) => {
    if (!authStore.isAuthenticated) return false
    
    loading.value.remove = true
    try {
      await useBaseOFetchWithAuth(API_ENDPOINTS.protected.favorites.delete(product.id), {
        method: 'DELETE'
      })

      product.is_favorite = false
      return true
    } finally {
      loading.value.remove = false
    }
  }

  // Favori durumunu değiştir (ekleme)
  const toggleFavorite = async (product) => {
    if (product.is_favorite) {
      return await removeFromFavorites(product)
    } else {
      return await addToFavorites(product)
    }
  }

  return {
    favorites,
    loading,
    fetchFavorites,
    addToFavorites,
    removeFromFavorites,
    toggleFavorite
  }
} 
